module.exports = __webpack_public_path__ + "static/media/transaction.e041a0b3.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/transaction.PNG
// module id = 566
// module chunks = 0